<script lang="ts">
	import { onMount } from "svelte"

	import Header from "../../../reusable/Header.svelte"

	import { AccountsStore } from "../../../../stores/data/AccountsStore"

	import {
		DataHandlerDesign,
		DataHandlerUserAdmin,
		Design,
		Device,
		Media,
		type User,
		DataHandlerMediaAdmin,
		DataHandlerDeviceAdmin,
	} from "luxedo-data"
	import UserInfo from "./UserInfo.svelte"
	import { Switch } from "misc-ui"
	import UserListDevice from "./UserListDevice.svelte"
	import UserListMedia from "./UserListMedia.svelte"
	import UserListProject from "./UserListProject.svelte"
	import LoadingSpinner from "../../../reusable/loaders/LoadingSpinner.svelte"

	interface Props {
		user: User
		params: any
	}

	let { user = $bindable(), params }: Props = $props()

	let isLoading = $state(true)

	let currentlyViewing = $state("device")
	let associatedData: {
		projects: Array<Design>
		devices: Array<Device>
		media: Array<Media>
	} = $state({
		projects: [],
		devices: [],
		media: [],
	})

	async function updateAssociatedData(user: User) {
		isLoading = true
		const { fileIDs, deviceIDs } = await DataHandlerUserAdmin.getAssociatedIds(user)
		const projList = []
		const mediaList = []
		if (fileIDs.length) await DataHandlerMediaAdmin.pull(fileIDs)
		if (deviceIDs.length) {
			await DataHandlerDeviceAdmin.pull(deviceIDs)
			// @ts-ignore
			associatedData.devices = DataHandlerDeviceAdmin.getMany(deviceIDs)
		} else {
			associatedData.devices = []
		}

		for (const id of fileIDs) {
			const media = DataHandlerMediaAdmin.get(id)
			if (media) mediaList.push(media)
			else {
				const project = DataHandlerDesign.get(id)
				projList.push(project)
			}
		}

		associatedData.media = mediaList
		associatedData.projects = projList
		isLoading = false
	}

	onMount(() => {
		const userID = params.id
		DataHandlerUserAdmin.pull([userID])
		AccountsStore.subscribe((users) => {
			user = users.find((u) => u.id == userID)
			if (user) updateAssociatedData(user)
		})
	})
</script>

<Header heading="{user?.firstname} {user?.lastname}" />

<Switch
	id="device-switch"
	bind:value={currentlyViewing}
	options={{
		Devices: "device",
		Media: "media",
		Projects: "project",
	}}
	small
/>

{#if user && !isLoading}
	<div class="flex-wrap">
		<UserInfo {user} />

		{#if currentlyViewing === "device"}
			<UserListDevice devices={associatedData.devices} />
		{:else if currentlyViewing === "media"}
			<UserListMedia allMedia={associatedData.media} />
		{:else if currentlyViewing === "project"}
			<UserListProject projects={associatedData.projects} />
		{/if}
	</div>
{:else}
	<main>
		<LoadingSpinner loadingText="Loading account" />
	</main>
{/if}

<style>
	:global(#device-switch) {
		position: absolute;
		top: 1rem;
		right: 1rem;
	}

	main {
		--loader-color: var(--color-accent);
		--loader-width: 20vw;

		width: 100%;
		height: calc(100vh - var(--header-height));
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
